exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clickable-card[data-v-44ad0624] {\n  cursor: pointer;\n  color: inherit;\n  transition: border-color 0.2s;\n}\n.clickable-card[data-v-44ad0624]:hover {\n  border-color: #00c8f8;\n}\n.clickable-card:hover .card-title[data-v-44ad0624] {\n  color: #00c8f8 !important;\n}\n", ""]);

// exports
